export function OutlineReceiveIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9984 6.99805H16.7808C17.5056 6.99805 18.168 7.40605 18.4944 8.04925L21 12.998V19.0796C21 20.1404 20.1408 20.9996 19.08 20.9996H4.92C3.8592 20.9996 3 20.1404 3 19.0796V12.998L5.65919 8.01564C5.99519 7.39165 6.64319 6.99805 7.35359 6.99805H8.00159"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9999 14.002H18.4991C17.6687 14.002 17.0015 14.674 17.0015 15.4996C17.0015 16.3299 16.3295 16.9971 15.5039 16.9971H8.50552C7.67512 16.9971 7.00792 16.3251 7.00792 15.4996C7.00792 14.6692 6.33592 14.002 5.51033 14.002H3.03833"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0049 3V12.9984L9.99854 11.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0049 12.9987L14.0017 11.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
